/** @module SourcingOrders/QuantityPerSize */
define([
	"dojo/_base/declare",
	"csi/heading/Number"
], function(declare,Number) {

	return declare(Number, {
		/**
		 * @override
		 * Render value for matrix cell
		 */
		toValue: function(ctx, h) {
			const order = ctx.getNodeContext();
			const size = ctx.getNodeURL();

			if (!order || !size) {
				return "";
			}
			const poProduct = ctx.cache.getNode(order.POProduct);
			const indexOfSize = poProduct && poProduct.ProductSizes.findIndex(s => s==size);

			const value = order.QuantityPerSize ? order.QuantityPerSize[indexOfSize] : "";
			return this.formatValue(value);
		}
	});
});